import Appsignal from '@appsignal/javascript';

const isProd = window && window.location?.hostname === 'app.getfoundation.com';

export const appsignal = new Appsignal({
  key: isProd ? '47aa1dbb-6227-4036-a09a-4f071d24339f' : '',
});
